var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"patsnap-avatar-renderer !inline-flex select-none items-center justify-center shadow",style:(_setup.styles)},[(_setup.visibleFirstChar)?_c('span',[_vm._v(_vm._s(_setup.props.avatar.firstChar))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }